import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
// Initialize GA4 with your measurement ID
ReactGA.initialize('G-TC7RP1QJZG');
export const GoogleAnalytics = () => {
  const location = useLocation();
  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search
    });
  }, [location]);
  return null;
};